import { Space, Button } from 'antd';
import { Header } from 'antd/es/layout/layout';
import React, { useCallback, useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import EcfmgLogo from '../../../assets/ecfmg_header_logo.png';
import { HandleLogout } from '../handle-logout';
import { useApolloClient } from '@apollo/client';
import { IsInStorybookEnv } from '../../../constants';
import { ApplicantSharedEcfmgHeaderContainerApplicantUserFieldsFragment } from '../../../generated';

interface EcfmgHeaderProps {
  data: ApplicantSharedEcfmgHeaderContainerApplicantUserFieldsFragment;
}

export const EcfmgHeader: React.FC<EcfmgHeaderProps> = (props) => {
  const auth = useAuth();
  const apolloClient = useApolloClient();

  const MOBILE_BREAKPOINT = 450; 
  const SM_LOGO_BREAKPOINT = 992;
  const MD_LOGO_BREAKPOINT = 768;

  const [loggedInName, setLoggedInName] = useState<string | null>(null);
  const [loggedInNameInitials, setLoggedInNameInitials] = useState<string | null>(null);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [smallPageWidthLogoSwitch, setSmallPageWidthLogoSwitch] = useState<boolean>(false);
  const [mediumPageWidthLogoSwitch, setMediumPageWidthLogoSwitch] = useState<boolean>(false);

  useEffect(() => {
    console.log('props.data ', props.data);
    if (props.data.personalInformation?.identityDetails?.legalNameConsistsOfOneName === true) {
      setLoggedInName(props.data.personalInformation?.identityDetails?.lastName || '');
      setLoggedInNameInitials(`${props.data.personalInformation?.identityDetails?.lastName?.charAt(0) || '?'}`);
    } else {
      console.log('false')
      setLoggedInName(`${props.data.personalInformation?.identityDetails?.restOfName} ${props.data.personalInformation?.identityDetails?.lastName}`);
      setLoggedInNameInitials(`${props.data.personalInformation?.identityDetails?.restOfName?.charAt(0) || '?'}${props.data.personalInformation?.identityDetails?.lastName?.charAt(0) || '?'}`);
    }
  }, [props.data]);


  const handleLogout = () => {
    HandleLogout(auth, apolloClient, window.location.origin);
  };

  const handleResize = useCallback(() => {
    if (typeof window !== 'undefined') {
    setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    setSmallPageWidthLogoSwitch(window.innerWidth <= SM_LOGO_BREAKPOINT);
    setMediumPageWidthLogoSwitch(window.innerWidth <= MD_LOGO_BREAKPOINT);
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
    setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    setSmallPageWidthLogoSwitch(window.innerWidth <= SM_LOGO_BREAKPOINT);
    setMediumPageWidthLogoSwitch(window.innerWidth <= MD_LOGO_BREAKPOINT);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
    }
  }, [handleResize]);

  useEffect(() => {
    // This is to set mock user's name in storybook
    let firstName = '';
    let lastName = '';
    if (IsInStorybookEnv()) {
      firstName = 'John';
      lastName = 'Doe';
      setLoggedInNameInitials(`${firstName.charAt(0) || '?'}${lastName.charAt(0) || '?'}`);
      setLoggedInName(`${firstName} ${lastName}`);
      return;
    }
  }, [auth]);

  const HeaderLeftCornerStyle = {
    maxWidth: "150px",
    marginLeft: isMobile ? "4px" : (mediumPageWidthLogoSwitch ? "4px" : (smallPageWidthLogoSwitch ? "-6px" : "4px")),
    
  };

  const HeaderLeftCorner = (
    <div style={{ flexShrink: 0 }}>
      <img style={HeaderLeftCornerStyle} src={EcfmgLogo} />
    </div>
  );

  const HeaderRightCorner = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Space direction="horizontal">
        <div
          style={{
            height: '30px',
            width: '30px',
            borderRadius: '15px',
            border: '1px solid white',
            textAlign: 'center',
            lineHeight: '30px'
          }}
        >
          {loggedInNameInitials || '?'}
        </div>
        <Space>
          {!isMobile && <div>{loggedInName}</div>}
          <Button style={{ color: 'white' }} type="link" onClick={handleLogout}>
            Logout
          </Button>
        </Space>
      </Space>
    </div>
  );

  return (
    <Header
      style={{
        background: '#3f4373',
        color: 'white',
        display: 'flex',
        padding: '0 16px',
        width: '100%',
        height: '60px',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'fixed',
        zIndex: 1000
      }}
    >
      {HeaderLeftCorner}
      {HeaderRightCorner}
    </Header>
  );
};